import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { useBi } from '@components/Hooks/useBi';
import { copyOfExploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { Box, IconButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { LinkSmall } from '@wix/wix-ui-icons-common';
import { FC } from 'react';
import s from './ProviderSocialLinks.module.scss';
import { FacebookSmall, InstagramSmall, LinkedInSmall } from './SocialIcons';

const ProviderSocialLinks: FC = () => {
  const logger = useBi();
  const { t } = useTranslation();
  const { sessionId } = useBiSessionContext();
  const {
    partnerProfile: { professionalInformation },
    entry,
    origin,
  } = useProfileContext();

  const biGenericClick = (clickType: string, data: string) => {
    logger.report(
      copyOfExploreResultsPageGenericClick({
        clickType,
        sessionId,
        origin,
        entry,
        exploreVersion: 'V2',
        data,
      }),
    );
  };

  const commonIconButtonProps = {
    skin: 'light' as const,
    size: 'tiny' as const,
    as: 'a' as const,
    target: '_blank',
    className: s.socialIcon,
  };

  return (
    <Box dataHook="provider-social-links" gap="3.33px">
      {professionalInformation?.socials?.linkedIn && (
        <IconButton
          {...commonIconButtonProps}
          dataHook="social-link-linkedin"
          href={professionalInformation.socials.linkedIn}
          onClick={() => biGenericClick('partners social media', 'LinkedIn')}
        >
          <LinkedInSmall />
        </IconButton>
      )}
      {professionalInformation?.socials?.instagram && (
        <IconButton
          {...commonIconButtonProps}
          dataHook="social-link-instagram"
          href={professionalInformation.socials.instagram}
          onClick={() => biGenericClick('partners social media', 'Instagram')}
        >
          <InstagramSmall />
        </IconButton>
      )}
      {professionalInformation?.socials?.facebook && (
        <IconButton
          {...commonIconButtonProps}
          dataHook="social-link-facebook"
          href={professionalInformation.socials.facebook}
          onClick={() => biGenericClick('partners social media', 'Facebook')}
        >
          <FacebookSmall />
        </IconButton>
      )}
      <IconButton
        {...commonIconButtonProps}
        dataHook="partner-business-website"
        href={professionalInformation?.businessWebsite}
        onClick={() => biGenericClick('partner website', '')}
      >
        <LinkSmall />
      </IconButton>
    </Box>
  );
};

export default ProviderSocialLinks;
